<template>
  <v-select
    class="custom-select-input"
    :disabled="disabled"
    v-model="ratingSystem"
    :items="ratingSystemList"
    :label="label"
    item-text="text"
    item-value="id"
    :rules="rules"
    validate-on-blur
    @change="onChange"
    :hint="hint"
    :persistent-hint="persistentHint"
  />
</template>

<script>
import CommonFieldTooltip from '@/components/tooltip/common-field-tooltip'

import { StudyProgramRatingSystemList } from '@/mixins/study-program-rating-system-list'

export default {
  components: {
    CommonFieldTooltip
  },
  mixins: [StudyProgramRatingSystemList],
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    value: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: false
    },
    rules: {
      type: Array,
      required: false,
      default: () => []
    },
    hint: {
      type: String,
      required: false
    },
    persistentHint: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    ratingSystem: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    onChange: function() {
      this.$emit('change')
    }
  }
}
</script>
